import { dateOfBirth, carNoBase ,petOfBirth} from './rules';
import { getDate } from 'date-fns';
import format from 'date-fns/format';

// select options
const typeOfMotor = [
  { label: '輕型機車 (50 c.c以下)', value: 'LMB' },
  { label: '重型機車（51c.c ~ 250c.c)', value: 'RHM' },
  { label: '大型重型機車（251 c.c以上)', value: 'HHM' }
];

const expectPremium = {
  travel: [
    { value: 100, label: '100萬' },
    { value: 200, label: '200萬' },
    { value: 300, label: '300萬' },
    { value: 400, label: '400萬' },
    { value: 500, label: '500萬' },
    { value: 600, label: '600萬' },
    { value: 700, label: '700萬' },
    { value: 800, label: '800萬' },
    { value: 900, label: '900萬' },
    { value: 1000, label: '1000萬' }
  ],  
  car: [
    { value: '1', label: '5,000元以下' },
    { value: '2', label: '5,001元 - 7,000元' },
    { value: '3', label: '7,001元 - 10,000元' },
    { value: '4', label: '10,000元以上' },
  ],
  motor: [
    { value: '1', label: '2,000元以下' },
    { value: '2', label: '2,001元 - 3,000元' },
    { value: '3', label: '3,001元 - 4,000元' },
    { value: '4', label: '4,000元以上' },
  ],
  accident: [
    { value: '1', label: '職業類別1' },
    { value: '2', label: '職業類別2' },
    { value: '3', label: '職業類別3' }    
  ],
  pet: [
    { value: '1', label: '2,000元以下' },  //{ value: '1', label: '2,000元以下' }  //20210701 Wen Modify
    //{ value: '2', label: '2,001元 - 3,000元' },
    { value: '3', label: '3,001元 - 4,000元' },//{ value: '3', label: '3,001元 - 4,000元' }
    //{ value: '4', label: '4,000元以上' },
  ],
  vaccine: [{ value: '1', label: '500元以下' }],
};

export const options = {
  expectPremium,
  typeOfMotor
};

// models
const isDevMode = process.env.NODE_ENV === 'development';

const vehicleBase = isDevMode
  ? {
      dateOfBirth: {
        year: '',
        month: '',
        day: ''
      },
      carNo: { block1: '6528', block2: 'QW' },
      expectPremium: '1',
    }
  : {
      dateOfBirth: {
        year: '',
        month: '',
        day: ''
      },
      carNo: { block1: '', block2: '' },
      expectPremium: '',
    };

export const travelModel = isDevMode
  ? {
      abroad: false,//abroad: true, 20201111 Wen modify 因應新冠肺炎 停止國外旅遊
      startTime: { date: '2019-11-21', time: '05:30' },
      endTime: { date: '2019-11-25', time: '05:30' },
      expectPremium: 500
    }
  : {
      abroad: false,//abroad: true, 20201111 Wen modify 因應新冠肺炎 停止國外旅遊
      startTime: { date: '', time: '' },
      endTime: { date: '', time: '' },
      expectPremium: '',
    };

export const carModel = {
  ...vehicleBase,
  gender: 'M',
  cdi: true
};

export const accidentModel = isDevMode
  ? {
    isbuy: false,
    otherjob: false,
      //abroad: false,//abroad: true, 20201111 Wen modify 因應新冠肺炎 停止國外旅遊
      accidentdate: format(new Date(Date.now()+86400000).toISOString().substring(0,10), "YYYY-MM-DD"),//{ date: format(new Date(Date.now()+86400000).toISOString().substring(0,10), "YYYY-MM-DD") },
     // endTime: { date: '2019-11-25' },
      expectPremium: '',
      accidentArea:{label:'0001001 內勤人員',value:'0001001 內勤人員 1'}//{label: null,value: null}//''//[{ value:''}]//null  //{label: '',value: ''} 20210315
    }
  : {
    isbuy: false,
    otherjob: false,
      //abroad: false,//abroad: true, 20201111 Wen modify 因應新冠肺炎 停止國外旅遊
      accidentdate:format(new Date(Date.now()+86400000).toISOString().substring(0,10), "YYYY-MM-DD"),// { date: format(new Date(Date.now()+86400000).toISOString().substring(0,10), "YYYY-MM-DD")},
      //endTime: { date: '' },
      expectPremium: '',
      accidentArea:{label:'0001001 內勤人員',value:'0001001 內勤人員 1'}//{label: null,value: null}//''//[{ value:''}]//{label: '',value: ''} // 20210315
    };

export const vaccineModel = isDevMode
  ? {  //20210530 Wen Add format(new Date().setDate(new Date().getDate() + 1), "YYYY-MM-DD")
      vaccineInceptionDate:  format(new Date(Date.now()+432000000).toISOString().substring(0,10), "YYYY-MM-DD"),//20220415 生效日期改回T+5//format(new Date(Date.now()+86400000).toISOString().substring(0,10), "YYYY-MM-DD"), //{ date: format(new Date(Date.now()+86400000).toDateString().substring(0,10), "YYYY-MM-DD")},
      expectPremium: '1',
      }
  : {
    //isbuy: false,    
      //abroad: false,//abroad: true, 20201111 Wen modify 因應新冠肺炎 停止國外旅遊 format(new Date().setDate(new Date().getDate() + 1), "YYYY-MM-DD")
      vaccineInceptionDate:  format(new Date(Date.now()+432000000).toISOString().substring(0,10), "YYYY-MM-DD"),//20220415 生效日期改回T+5 //format(new Date(Date.now()+86400000).toISOString().substring(0,10), "YYYY-MM-DD") ,  
      expectPremium: '1',   
      };
const motorCarNo = isDevMode ? { block1: 'LAC', block2: '123' } : { block1: '', block2: '' };
const typeOfMotorOption = isDevMode ? 'RHM' : '';

export const motorModel = {
  ...vehicleBase,
  carNo: motorCarNo,
  typeOfMotor: typeOfMotorOption
};

export const petModel = isDevMode
  ? {    
      typeOfPet: 'DOG',//abroad: true, 20201111 Wen modify 因應新冠肺炎 停止國外旅遊
      dateOfBirthPet: { 
                year: '',
                month: '',
                day: ''
                },
     // endTime: { date: '2019-11-25' },
      expectPremium: '',
      petGender:'M',
      petInceptionDate: format(new Date(Date.now()+86400000).toISOString().substring(0,10), "YYYY-MM-DD")// { date: format(new Date(Date.now()+86400000).toISOString().substring(0,10), "YYYY-MM-DD")},  //// 20210520 Wen Add format(new Date(), "YYYY-MM-DD")
      
    }
  : {    
      typeOfPet: 'DOG',//abroad: true, 20201111 Wen modify 因應新冠肺炎 停止國外旅遊
      dateOfBirthPet: {
                  year: '',
                  month: '',
                  day: '' 
                  },
      //endTime: { date: '' },
      expectPremium: '',
      petGender:'M',
      petInceptionDate: format(new Date(Date.now()+86400000).toISOString().substring(0,10), "YYYY-MM-DD")  // 20210520 Wen Add format(new Date(), "YYYY-MM-DD")
    };

// rules
const expectPremiumRule = { 
  required: true,
  trigger: 'blur',
  message: '請選擇您的期望保費'
};

const jobTypeRule = { 
  required: true,
  trigger: 'blur',
  message: '請選擇您的職業類別'
};

const timeRule = {
  type: 'object',
  fields: {
    date: [
      { type: 'string', required: true, message: '請選擇您的出發日期', trigger: 'validate' }
    ],
    time: [
      { type: 'string', required: true, message: '請輸入您的出發時間', trigger: 'validate' }
    ]
  },
  trigger: 'validate'
};
//20201211 Wen Add dateRule
const dateRule = {
  type: 'object', 
  fields: {
    date: [
      { type: 'string', required: true, message: '請選擇您的保險起始日期' }//, trigger: 'validate'
    ]
  },
  trigger: 'validate'
};

const vehicleRules = {
  dateOfBirth,
  carNo: carNoBase,
  expectPremium: expectPremiumRule,
};

export const travelRules = {
  startTime: timeRule,
  expectPremium: { ...expectPremiumRule, type: 'number' },
};
export const accidentRules = {  
  startTime: dateRule,
  expectPremium: { ...jobTypeRule },
};

export const petRules = {  
  dateOfBirthPet: petOfBirth,
  expectPremium: { ...expectPremiumRule},
};

export const vaccineRules = {  
  startTime: dateRule, 
};

export const carRules = { ...vehicleRules };

export const motorRules = { 
  ...vehicleRules,
  typeOfMotor: [{ required: true, message: '請選擇您的車種', trigger: 'blur' }]
};